package dairy.mynotes.repository

import kotlin.js.Date

actual fun currentTimeMillis(): Long = Date.now().toLong()

// JS Firestore SDK rejects Kotlin Long (it's a custom object in JS IR).
// Convert to Double so Firestore stores it as a plain JS number.
actual fun Long.toFirestoreValue(): Any = this.toDouble()
